export default __webpack_public_path__ + "static/media/takkSmilefjes.05170b4a.svg";